"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const FileLink = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 12,
  height: 16,
  viewBox: "0 0 12 16",
  fill: "none"
}, props), _react.default.createElement("path", {
  d: "M7.5 0h-6C.667 0 0 .72 0 1.6v12.8c0 .888.667 1.6 1.5 1.6h9c.832 0 1.5-.712 1.5-1.6V4.8L7.5 0zm3 14.4h-9V1.6h5.25v4h3.75v8.8zm-5.25-.8h-.188c-.974 0-2.812-.624-2.812-3s1.838-3 2.813-3h.187v1.2h-.188c-.277 0-1.687.104-1.687 1.8 0 1.752 1.5 1.8 1.688 1.8h.187v1.2zm2.25-2.4h-3V10h3v1.2zm-.75-3.6h.188c.974 0 2.812.624 2.812 3s-1.838 3-2.813 3H6.75v-1.2h.188c.277 0 1.687-.104 1.687-1.8 0-1.752-1.5-1.8-1.688-1.8H6.75V7.6z",
  className: "fill"
}));

var _default = FileLink;
exports.default = _default;